import { Globe, RefreshCw } from "lucide-react";
import { useSubscriptionAnalytics } from "./hooks/useSubscriptionAnalytics";
import AnalyticsFilters from "./components/AnalyticsFilters";
import AnalyticsSummary from "./components/AnalyticsSummary";
import AnalyticsCharts from "./components/AnalyticsCharts";
import AnalyticsTable from "./components/AnalyticsTable";

export default function SubscriptionAnalytics() {
  const {
    filters,
    isLoading,
    processedData,
    summaryMetrics,
    planData,
    uniquePlans,
    uniqueStatuses,
    handleFilterChange,
    resetFilters,
  } = useSubscriptionAnalytics();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8">
          <h1 className="mb-2 flex items-center gap-3 text-3xl font-bold text-gray-900 md:text-4xl">
            <Globe className="text-blue-600" />
            International & Indian Subscriber Dashboard
          </h1>
          <p className="text-gray-600">
            Comprehensive analytics for subscriber growth, revenue, and engagement metrics
          </p>
        </div>

        <AnalyticsFilters
          filters={filters}
          uniquePlans={uniquePlans}
          uniqueStatuses={uniqueStatuses}
          onFilterChange={handleFilterChange}
          onReset={resetFilters}
        />

        {isLoading ? (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20">
            <div className="flex items-center gap-3 rounded-lg bg-white p-6 shadow-lg">
              <RefreshCw className="animate-spin text-blue-600" size={24} />
              <span className="text-gray-700">Updating dashboard...</span>
            </div>
          </div>
        ) : null}

        <AnalyticsSummary summaryMetrics={summaryMetrics} />
        <AnalyticsCharts processedData={processedData} planData={planData} groupBy={filters.groupBy} />
        <AnalyticsTable processedData={processedData} groupBy={filters.groupBy} />
      </div>
    </div>
  );
}
